(() => {
  class PharmaciesController {
    constructor($scope, toastr, Pharmacy, Utils) {
      'ngInject';

      Object.assign(this, {
        $scope,
        toastr,
        Pharmacy,
        Utils,
        serviceLevels: this.createSelectableArray(Pharmacy.serviceLevels),
        // specialties: this.createSelectableArray(Pharmacy.specialties),
        specialties: Pharmacy.selectableSpecialties,
        hideFilters: false,
        pharmacies: [],
        query: {
          paged_format: true,
          specialties: [],
          service_levels: [],
          // Default address properties passed in from patient
          state: $scope.ngDialogData.address.state
        },
        autoRefillTab: $scope.ngDialogData.autoRefillTab,
        pagination: {
          limit: 300,
          offset: 0
        }
      }); // COMMENTED FOR BOOTS
      //
      // angular.forEach(this.specialties, function(value, key){
      //   if(value.code == "retail"){
      //     value.selected = true;
      //   }
      // });
    }

    getPharmacySpecialties(pharmacy = {}) {
      if (!pharmacy.specialties) {
        return;
      }

      const {
        specialties
      } = pharmacy;
      return Object.keys(specialties).filter(s => specialties[s]).map(s => s.replace(/_/g, ' ').capitalize());
    }

    createSelectableArray(arrayOfStrings) {
      return arrayOfStrings.map(s => ({
        display: s.split('_').join(' '),
        code: s,
        selected: false
      }));
    }
    /**
     * Determines if more pharmacies can be loaded
     * @returns {boolean} t/f
     */


    hasMorePharmacies() {
      return this.pagination.limit + this.pagination.offset <= this.pagination.total;
    }
    /**
     * General search for pharmacies
     * @param {string} loadingKey - determines which button to show loader on
     */


    search(loadingKey) {
      if (loadingKey === 'searching') {
        this.pharmacies = [];
        this.pagination.offset = 0;
      }

      this[loadingKey] = true;
      this.Pharmacy.search(Object.assign({}, this.query, this.pagination)).then(({
        data
      }) => {
        const {
          data: pharmacies,
          pagination
        } = data;
        this.pharmacies.push(...pharmacies);
        pagination.offset += pagination.limit;
        Object.assign(this.pagination, pagination);
      }).catch(err => {
        this.toastr.error(this.Utils.getApiErrorMessage(err));
      }).finally(() => {
        this[loadingKey] = false;
      });
    }

  }

  PharmaciesController.$inject = ["$scope", "toastr", "Pharmacy", "Utils"];
  angular.module('pims').controller('PharmaciesController', PharmaciesController);
})();
